import {
  CUSTOMIZER,
  DELIVERY_LOCATOR,
  FALLBACK_NA,
  MENU,
  ORDER_CONFIRMATION,
  ORDER_MANAGEMENT,
  PROFILE,
  RESTAURANT,
} from '../constants/AnalyticsConstants';
import { useEffect } from 'react';
import { getScreenBreakpoint, getLocalTime } from '../Utils/analyticsUtils';
import useStore from '../store/useStore';
import { pageName, pageSection, reactAttemptTrack } from '../components/Analytics/AnalyticsNew';
import { matchUrl } from '../Utils/componentUtils';
import { multipleAndCheck, ternaryCheck } from '../Utils/WindowUtils';

const useAnalytics = ({ ...props }) => {
  const {
    analyticsProducts,
    pageDetails,
    attemptTracter,
    isSetFavourite,
    isSetBestSeller,
    totalCards,
    selectedCard,
    cartID,
  } = useStore();
  const getBestSeller = ternaryCheck(isSetBestSeller, 'best sellers', '');
  const favOrBestSeller = ternaryCheck(isSetFavourite, 'favorites', getBestSeller);
  const matchedHost = window.location.host.match(/(?:^|\.)([\w-]+)\.com(?:[./]|$)/)?.[1];
  useEffect(() => {
    const pagesArray = [
      RESTAURANT,
      MENU,
      ORDER_MANAGEMENT,
      CUSTOMIZER,
      ORDER_CONFIRMATION,
      PROFILE,
      DELIVERY_LOCATOR,
    ];
    if (matchUrl(pagesArray)) {
      window.fwhtrk_new = {
        page: {
          hostName: ternaryCheck(matchedHost, matchedHost, ''),
          section: analyticsProducts?.sectionName ?? pageDetails ?? pageSection(props.pageName),
          name: analyticsProducts?.pageName ?? pageDetails ?? pageName(props.pageName),
          locale: props.languageCode,
          componentTitle: ternaryCheck(analyticsProducts?.componentTitle, analyticsProducts?.componentTitle, ''),
          clickActionName: ternaryCheck(analyticsProducts?.clickActionName, analyticsProducts?.clickActionName, ''),
          virtualName: ternaryCheck(analyticsProducts?.virtualName, analyticsProducts?.virtualName, ''),
          type: ternaryCheck(analyticsProducts?.type, analyticsProducts?.type, ''),
          promoCode: ternaryCheck(analyticsProducts?.promoCode, analyticsProducts?.promoCode, ''),
          orderStatus: ternaryCheck(analyticsProducts?.orderStatus, analyticsProducts?.orderStatus, ''),
          comboOptionName: ternaryCheck(analyticsProducts?.comboOptionName, analyticsProducts?.comboOptionName, ''),
        },
        event: {
          errorMessage: ternaryCheck(analyticsProducts?.errorMessageEvent, analyticsProducts?.errorMessageEvent, 0),
          warningMessage: ternaryCheck(analyticsProducts?.warningMessageUI, analyticsProducts?.warningMessageUI, 0),
          errorMessageMW: ternaryCheck(analyticsProducts?.errorMessageMW, analyticsProducts?.errorMessageMW, 0),
          errorMessageUI: ternaryCheck(analyticsProducts?.errorMessageUI, analyticsProducts?.errorMessageUI, 0),
          bannerImpression: ternaryCheck(analyticsProducts?.bannerMessageEvent, analyticsProducts?.bannerMessageEvent, 0),
          bannerDismiss: ternaryCheck(analyticsProducts?.bannerDismiss, analyticsProducts?.bannerDismiss, 0),
          cartOpen: ternaryCheck(analyticsProducts?.cartOpen, analyticsProducts?.cartOpen, 0),
          toasted: ternaryCheck(analyticsProducts?.toasted, analyticsProducts?.toasted, 0),
          upsellProductAdded: ternaryCheck(analyticsProducts?.upsellProductAddedEvent, analyticsProducts?.upsellProductAddedEvent, 0),
          startonlineorder: ternaryCheck(analyticsProducts?.startonlineorder, analyticsProducts?.startonlineorder, 0),
          itemaddedtobag: ternaryCheck(analyticsProducts?.itemaddedtobag, analyticsProducts?.itemaddedtobag, 0),
          productPriceAdded: ternaryCheck(analyticsProducts?.productPriceAdded, analyticsProducts?.productPriceAdded, 0),
          productQuantityAdded: ternaryCheck(analyticsProducts?.productQuantityAdded, analyticsProducts?.productQuantityAdded, 0),
          ComboPriceAdded: ternaryCheck(analyticsProducts?.ComboPriceAdded, analyticsProducts?.ComboPriceAdded, 0),
          MIAMPriceAdded: ternaryCheck(analyticsProducts?.MIAMPriceAdded, analyticsProducts?.MIAMPriceAdded, 0),
          ExtrasPriceAdded: ternaryCheck(analyticsProducts?.ExtrasPriceAdded, analyticsProducts?.ExtrasPriceAdded, 0),
          sandwichCustomized: ternaryCheck(analyticsProducts?.sandwichCustomized, analyticsProducts?.sandwichCustomized, 0),
          CYO: ternaryCheck(analyticsProducts?.CYO, analyticsProducts?.CYO, 0),
          productPriceCheckout: ternaryCheck(analyticsProducts?.productPriceCheckout, analyticsProducts?.productPriceCheckout, 0),
          productQuantityCheckout: ternaryCheck(analyticsProducts?.productQuantityCheckout, analyticsProducts?.productQuantityCheckout, 0),
          MIAMPriceCheckout: ternaryCheck(analyticsProducts?.MIAMPriceCheckout, analyticsProducts?.MIAMPriceCheckout, 0),
          ExtrasPriceCheckout: ternaryCheck(analyticsProducts?.ExtrasPriceCheckout, analyticsProducts?.ExtrasPriceCheckout, 0),
          ComboPriceCheckout: ternaryCheck(analyticsProducts?.ComboPriceCheckout, analyticsProducts?.ComboPriceCheckout, 0),
          vechicleSelected: ternaryCheck(analyticsProducts?.vechicleSelected, analyticsProducts?.vechicleSelected, 0),
          productPriceUpdate: ternaryCheck(analyticsProducts?.productPriceUpdate, analyticsProducts?.productPriceUpdate, 0),
          productQuantityUpdate: ternaryCheck(analyticsProducts?.productQuantityUpdate, analyticsProducts?.productQuantityUpdate, 0),
          MIAMPriceUpdate: ternaryCheck(analyticsProducts?.MIAMPriceUpdate, analyticsProducts?.MIAMPriceUpdate, 0),
          kidsMealContinue: ternaryCheck(analyticsProducts?.kidsMealContinue, analyticsProducts?.kidsMealContinue, 0),
          kidsMealSelected: ternaryCheck(analyticsProducts?.kidsMealSelected, analyticsProducts?.kidsMealSelected, 0),
          ExtrasPriceUpdate: ternaryCheck(analyticsProducts?.ExtrasPriceUpdate, analyticsProducts?.ExtrasPriceUpdate, 0),
          updateCart: ternaryCheck(analyticsProducts?.updateCart, analyticsProducts?.updateCart, 0),
          MIAMSelected: ternaryCheck(analyticsProducts?.MIAMSelected, analyticsProducts?.MIAMSelected, 0),
          ComboPriceUpdate: ternaryCheck(analyticsProducts?.ComboPriceUpdate, analyticsProducts?.ComboPriceUpdate, 0),
          drinkSelected: ternaryCheck(analyticsProducts?.drinkSelected, analyticsProducts?.drinkSelected, 0),
          itemRemoved: ternaryCheck(analyticsProducts?.itemRemoved, analyticsProducts?.itemRemoved, 0),
          productPriceRemove: ternaryCheck(analyticsProducts?.productPriceRemove, analyticsProducts?.productPriceRemove, 0),
          productQuantityRemove: ternaryCheck(analyticsProducts?.productQuantityRemove, analyticsProducts?.productQuantityRemove, 0),
          MIAMPriceRemove: ternaryCheck(analyticsProducts?.MIAMPriceRemove, analyticsProducts?.MIAMPriceRemove, 0),
          ExtrasPriceRemove: ternaryCheck(analyticsProducts?.ExtrasPriceRemove, analyticsProducts?.ExtrasPriceRemove, 0),
          ComboPriceRemove: ternaryCheck(analyticsProducts?.ComboPriceRemove, analyticsProducts?.ComboPriceRemove, 0),
          promoApplied: ternaryCheck(analyticsProducts?.promoApplied, analyticsProducts?.promoApplied, 0),
          promoError: ternaryCheck(analyticsProducts?.promoError, analyticsProducts?.promoError, 0),
          curbsideSelected: ternaryCheck(analyticsProducts?.curbsideSelected, analyticsProducts?.curbsideSelected, 0),
          warningMessageEvent: ternaryCheck(analyticsProducts?.warningMessageEvent, analyticsProducts?.warningMessageEvent, 0),
          placeOrderEvent: ternaryCheck(analyticsProducts?.placeOrderEvent, analyticsProducts?.placeOrderEvent, 0),
          checkoutstarted: ternaryCheck(analyticsProducts?.checkoutstarted, analyticsProducts?.checkoutstarted, 0),
          bagViewed: ternaryCheck(analyticsProducts?.bagViewed, analyticsProducts?.bagViewed, 0),
          productPriceView: ternaryCheck(analyticsProducts?.productPriceView, analyticsProducts?.productPriceView, 0),
          productQuantityView: ternaryCheck(analyticsProducts?.productQuantityView, analyticsProducts?.productQuantityView, 0),
          MIAMPriceView: ternaryCheck(analyticsProducts?.MIAMPriceView, analyticsProducts?.MIAMPriceView, 0),
          ExtrasPriceView: ternaryCheck(analyticsProducts?.ExtrasPriceView, analyticsProducts?.ExtrasPriceView, 0),
          ComboPriceView: ternaryCheck(analyticsProducts?.ComboPriceView, analyticsProducts?.ComboPriceView, 0),
          itemViewed: ternaryCheck(analyticsProducts?.itemViewed, analyticsProducts?.itemViewed, 0),
          orderFavorited: ternaryCheck(analyticsProducts?.orderFavorited, analyticsProducts?.orderFavorited, 0),
          promoView: ternaryCheck(analyticsProducts?.promoView, analyticsProducts?.promoView, 0),
          clicktocall: ternaryCheck(analyticsProducts?.clicktocall, analyticsProducts?.clicktocall, 0),
          storeGetDirections: ternaryCheck(analyticsProducts?.storeGetDirections, analyticsProducts?.storeGetDirections, 0),
          purchase: ternaryCheck(analyticsProducts?.purchase, analyticsProducts?.purchase, 0),
          certificateDiscount: ternaryCheck(analyticsProducts?.certificateDiscount, analyticsProducts?.certificateDiscount, 0),
          discount: ternaryCheck(analyticsProducts?.discount, analyticsProducts?.discount, 0),
          tax: ternaryCheck(analyticsProducts?.tax, analyticsProducts?.tax, ''),
          certsApplied: ternaryCheck(analyticsProducts?.certsApplied, analyticsProducts?.certsApplied, 0),
          curbsideDelivery: ternaryCheck(analyticsProducts?.curbsideDelivery, analyticsProducts?.curbsideDelivery, 0),
          rewardApplied: ternaryCheck(analyticsProducts?.rewardApplied, analyticsProducts?.rewardApplied, 0),
          MIAMPricePurchase: ternaryCheck(analyticsProducts?.MIAMPricePurchase, analyticsProducts?.MIAMPricePurchase, 0),
          ExtrasPricePurchase: ternaryCheck(analyticsProducts?.ExtrasPricePurchase, analyticsProducts?.ExtrasPricePurchase, 0),
          ComboPricePurchase: ternaryCheck(analyticsProducts?.ComboPricePurchase, analyticsProducts?.ComboPricePurchase, 0),
          sandwichArtistTipAmount: ternaryCheck(analyticsProducts?.sandwichArtistTipAmount, analyticsProducts?.sandwichArtistTipAmount, 0),
          subTotal: ternaryCheck(analyticsProducts?.subTotal, analyticsProducts?.subTotal, 0),
          orderTax: ternaryCheck(analyticsProducts?.orderTax, analyticsProducts?.orderTax, 0),
          deliveryFees: ternaryCheck(analyticsProducts?.deliveryFees, analyticsProducts?.deliveryFees, ''),
          driverTipAmount: ternaryCheck(analyticsProducts?.driverTipAmount, analyticsProducts?.driverTipAmount, ''),

          rewardItemRemoved: ternaryCheck(analyticsProducts?.rewardItemRemoved, analyticsProducts?.rewardItemRemoved, 0),
          dealRemoved: ternaryCheck(analyticsProducts?.dealRemoved, analyticsProducts?.dealRemoved, 0),
          loggedout: ternaryCheck(analyticsProducts?.loggedout, analyticsProducts?.loggedout, 0),

          attemptAccountToDelete :ternaryCheck(analyticsProducts?.attemptAccountToDelete, analyticsProducts?.attemptAccountToDelete, 0),
          utensilSelected : ternaryCheck(analyticsProducts?.utensilSelected, analyticsProducts?.utensilSelected, 0),
          viewRewards: ternaryCheck(analyticsProducts?.viewRewards, analyticsProducts?.viewRewards, 0), 
          deliverySearch: ternaryCheck(analyticsProducts?.deliverySearch, analyticsProducts?.deliverySearch, 0),
          restaurantSelected: ternaryCheck(analyticsProducts?.restaurantSelected, analyticsProducts?.restaurantSelected, 0),
          delivery: ternaryCheck(analyticsProducts?.delivery, analyticsProducts?.delivery, 0),
          pickup: ternaryCheck(analyticsProducts?.pickup, analyticsProducts?.pickup, 0),
          driveThru: ternaryCheck(analyticsProducts?.driveThru, analyticsProducts?.driveThru, 0),
          rewardPoints: ternaryCheck(analyticsProducts?.rewardPoints, analyticsProducts?.rewardPoints, 0),
          rewardPrice: ternaryCheck(analyticsProducts?.rewardPrice, analyticsProducts?.rewardPrice, 0),
          dealRedeemed: ternaryCheck(analyticsProducts?.dealRedeemed, analyticsProducts?.dealRedeemed, 0),
          orderDetails: ternaryCheck(multipleAndCheck(window.orderViewModel?.orderStatusClicked, props?.pageName == "order-confirmation"), 1, 0),
          quickAddonSelected: ternaryCheck(analyticsProducts?.quickAddonSelected, analyticsProducts?.quickAddonSelected, 0),
          comboOrdered: ternaryCheck(analyticsProducts?.comboOrdered, analyticsProducts?.comboOrdered, 0),
          quickAddonOrdered: ternaryCheck(analyticsProducts?.quickAddonOrdered, analyticsProducts?.quickAddonOrdered, 0),
          comboSelected: ternaryCheck(analyticsProducts?.comboSelected, analyticsProducts?.comboSelected, 0),
          sauceCustomized: ternaryCheck(analyticsProducts?.sauceCustomized, analyticsProducts?.sauceCustomized, 0),
          todaysdealAdded: ternaryCheck(analyticsProducts?.todaysdealAdded, analyticsProducts?.todaysdealAdded, 0),
          todaysMealDealRedeemed: ternaryCheck(analyticsProducts?.todaysMealDealRedeemed, analyticsProducts?.todaysMealDealRedeemed, 0),
          kidsMealOrdered: ternaryCheck(analyticsProducts?.kidsMealOrdered, analyticsProducts?.kidsMealOrdered, 0),
          collectibleCupSelected: ternaryCheck(analyticsProducts?.collectibleCupSelected, analyticsProducts?.collectibleCupSelected, 0),
          collectibleCupRemoved: ternaryCheck(analyticsProducts?.collectibleCupRemoved, analyticsProducts?.collectibleCupRemoved, 0),
          collectibleCupOrdered: ternaryCheck(analyticsProducts?.collectibleCupOrdered, analyticsProducts?.collectibleCupOrdered, 0),
          giftCardReloadSuccess: ternaryCheck(analyticsProducts?.giftCardReloadSuccess, analyticsProducts?.giftCardReloadSuccess, 0),
          paymentMethodRemoved: ternaryCheck(analyticsProducts?.paymentMethodRemoved, analyticsProducts?.paymentMethodRemoved, 0),
          giftCardTransferBalance: ternaryCheck(analyticsProducts?.giftCardTransferBalance, analyticsProducts?.giftCardTransferBalance, 0),
          switchOrderType: ternaryCheck(analyticsProducts?.switchOrderType, analyticsProducts?.switchOrderType, 0),
          vehicleSelected: ternaryCheck(analyticsProducts?.vehicleSelected, analyticsProducts?.vehicleSelected, 0),
          noOfDeals: ternaryCheck(analyticsProducts?.noOfDeals, analyticsProducts?.noOfDeals, 0),
          promoSecondaryCTAClick: ternaryCheck(analyticsProducts?.promoSecondaryCTAClick, analyticsProducts?.promoSecondaryCTAClick, 0),
          dealApplied: ternaryCheck(analyticsProducts?.dealApplied, analyticsProducts?.dealApplied, 0),
          orderCancel: ternaryCheck(analyticsProducts?.orderCancel, analyticsProducts?.orderCancel, 0)
        },
        cartID: cartID || analyticsProducts.cartID || '',
        totalCards: ternaryCheck(totalCards, totalCards, 0),
        onCardClick: ternaryCheck(selectedCard, selectedCard, 0),
        DBFavoritesOrBestsellers: favOrBestSeller,
        productCategory: ternaryCheck(analyticsProducts?.productCategory, analyticsProducts?.productCategory, ''),
        products: ternaryCheck(analyticsProducts?.products, analyticsProducts?.products, []),
        removedProduct: ternaryCheck(analyticsProducts?.removedProduct, analyticsProducts?.removedProduct, []),
        warningMessage: ternaryCheck(analyticsProducts?.warningMessage, analyticsProducts?.warningMessage, ''),
        errorMessage: ternaryCheck(analyticsProducts?.errorMessage, analyticsProducts?.errorMessage, ''),
        parentErrorCode: ternaryCheck(analyticsProducts?.parentErrorCode, analyticsProducts?.parentErrorCode, ''),
        childErrorCode: ternaryCheck(analyticsProducts?.childErrorCode, analyticsProducts?.childErrorCode, ''),
        bannerMessage: ternaryCheck(analyticsProducts?.bannerMessage, analyticsProducts?.bannerMessage, ''),
        orderSourceType: ternaryCheck(analyticsProducts?.orderSourceType, analyticsProducts?.orderSourceType, ''),
        offerID: ternaryCheck(analyticsProducts?.offerID, analyticsProducts?.offerID, ''),
        offerDesc: ternaryCheck(analyticsProducts?.offerDesc, analyticsProducts?.offerDesc, ''),
        itemFavoritedOrderID: ternaryCheck(analyticsProducts?.itemFavoritedOrderID, analyticsProducts?.itemFavoritedOrderID, ''),
        itemFavoritedProductID: ternaryCheck(analyticsProducts?.itemFavoritedProductID, analyticsProducts?.itemFavoritedProductID, ''),
        transactionID: ternaryCheck(analyticsProducts?.transactionID, analyticsProducts?.transactionID, ''),
        ConsumerPrice: ternaryCheck(analyticsProducts?.ConsumerPrice, analyticsProducts?.ConsumerPrice, ''),
        itemUnits: ternaryCheck(analyticsProducts?.itemUnits, analyticsProducts?.itemUnits, ''),
        itemPrice: ternaryCheck(analyticsProducts?.itemPrice, analyticsProducts?.itemPrice, ''),
        billingZip: ternaryCheck(analyticsProducts?.billingZip, analyticsProducts?.billingZip, ''),
        paymentMethod: ternaryCheck(analyticsProducts?.paymentMethod, analyticsProducts?.paymentMethod, ''),
        orderValue: ternaryCheck(analyticsProducts?.orderValue, analyticsProducts?.orderValue, ''),
        currency: ternaryCheck(analyticsProducts?.currency, analyticsProducts?.currency, ''),
        purchaseID: ternaryCheck(analyticsProducts?.purchaseID, analyticsProducts?.purchaseID, ''),
        certificateApplied: ternaryCheck(analyticsProducts?.certificateApplied, analyticsProducts?.certificateApplied, ''),
        certDiscAmt: ternaryCheck(analyticsProducts?.certDiscAmt, analyticsProducts?.certDiscAmt, ''),
        sandwichArtistTipPercent: ternaryCheck(analyticsProducts?.sandwichArtistTipPercent, analyticsProducts?.sandwichArtistTipPercent, ''),
        rewardName: ternaryCheck(analyticsProducts?.rewardName, analyticsProducts?.rewardName, ''),
        utensilName : ternaryCheck(analyticsProducts?.utensilName, analyticsProducts?.utensilName, ''),
        // products: {
        //   orderSource: analyticsProducts.orderSource || FALLBACK_NA,
        //   productDetails: analyticsProducts.productDetails|| FALLBACK_NA,
        //   toastBanner: analyticsProducts.toastBanner|| FALLBACK_NA,
        //   isModalOpen:analyticsProducts.isModalOpen || false,
        //   isModalClose:analyticsProducts.isModalClose || false,
        //   errorModalName: analyticsProducts.errorModalName || FALLBACK_NA,
        //   warningMessage: analyticsProducts.warningMessage || FALLBACK_NA,
        //   errorMessage: analyticsProducts.errorMessage || FALLBACK_NA,
        //   buttonName: analyticsProducts.buttonName || FALLBACK_NA,
        //   ...analyticsProducts
        // },
        loginStatus: ternaryCheck(props?.loggedIn, true, false),
        storeCountry: ternaryCheck(orderViewModel,
          orderViewModel.store.storeCountry || CONSTANTS.fallback_country,
          FALLBACK_NA),
        storeRegion: ternaryCheck(multipleAndCheck(orderViewModel, orderViewModel?.store?.storeCountry == "PR"),
          orderViewModel.store.storeCountry || CONSTANTS.fallback_country,
          FALLBACK_NA),
        orderType: ternaryCheck(orderViewModel?.orderType, orderViewModel?.orderType, FALLBACK_NA),
        storeStatus:orderViewModel.analyticsStoreStatus,
        storeID: ternaryCheck(orderViewModel, orderViewModel?.store?.id || orderViewModel?.store?.StoreId || FALLBACK_NA, FALLBACK_NA),
        storeLanguage: ternaryCheck(orderViewModel?.headerFooterLanguageCode,
          orderViewModel?.headerFooterLanguageCode?.substring(0, 2), FALLBACK_NA),
        guestCountry: ternaryCheck(orderViewModel,
          orderViewModel?.Analytics?.guestCountry || analyticsProducts.guestCountry || CONSTANTS.fallback_country || FALLBACK_NA,
          FALLBACK_NA),
        loyaltyActiveFlag:
          ternaryCheck(orderViewModel?.LoyaltyOption != null, orderViewModel?.LoyaltyOption, FALLBACK_NA),
        loyaltyID: ternaryCheck(orderViewModel?.hasLoggedIn, dtmLoyaltyId, FALLBACK_NA),
        emailOptIn:
          ternaryCheck(orderViewModel?.EmailOptInProfile != null, orderViewModel?.EmailOptInProfile, FALLBACK_NA),
        localTime: getLocalTime(),
        tierLevel: ternaryCheck(orderViewModel?.hasLoggedIn, orderViewModel?.Analytics?.tierLevel, FALLBACK_NA),
        user: {
          promo: ternaryCheck(analyticsProducts?.promo, analyticsProducts?.promo, []),
          promolist: ternaryCheck(analyticsProducts?.promolist, analyticsProducts?.promolist, ''),
          dealplu: ternaryCheck(analyticsProducts?.dealplu, analyticsProducts?.dealplu, '')
        },
        leadTimeSelected: ternaryCheck(analyticsProducts?.leadTimeSelected, analyticsProducts?.leadTimeSelected, 0),
        orderAheadDate : ternaryCheck(analyticsProducts?.orderAheadDate, analyticsProducts?.orderAheadDate, ''),
        recCriteria: ternaryCheck(analyticsProducts?.recCriteria, analyticsProducts?.recCriteria, ''),
        productStream: ternaryCheck(analyticsProducts?.productStream, analyticsProducts?.productStream, ''),
        rewardMessage: ternaryCheck(analyticsProducts?.rewardMessage, analyticsProducts?.rewardMessage, ''),
      };
    }
  }, [props, orderViewModel, analyticsProducts]);

  useEffect(() => {
    const pagesArray = [
      RESTAURANT,
      MENU,
      ORDER_MANAGEMENT,
      CUSTOMIZER,
      ORDER_CONFIRMATION,
      PROFILE,
      DELIVERY_LOCATOR,
    ];
    if (matchUrl(pagesArray)) {
      if (attemptTracter.length > 0) {
        reactAttemptTrack(attemptTracter);
      }
    }
  }, [attemptTracter]);
};

export default useAnalytics;

export const CONSTANTS = {
  fallback_country: FALLBACK_NA,
};

export const UTIL_FUNCTIONS = {
  getScreenBreakpoint: getScreenBreakpoint,
};
